
import { mapActions, mapGetters } from "vuex";
import filters from "~/mixins/filters";

export default {
  mixins: [filters],
  props: {
    isText: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      offer: "catalog/catalog-cars/offer",
      likesArray: "favorite/favorite/likesArray",
      settings: "settings/settings/settings"
    })
  },
  methods: {
    async callback() {
      let payload = {
        modal_component: "modal-callback-main"
      };
      await this.openModal(payload);
    },
    async credit() {
      this.$router.push({
        path: "/credit",
        query: {
          mark: this.offer.mark.slug,
          model: this.offer.folder.slug,
          car: this.offer.external_id,
          fromCard: true
        }
      });
    },
    traidIn() {
      this.$router.push({
        path: "/trade-in",
        query: {
          mark: this.offer.mark.slug,
          model: this.offer.folder.slug,
          car: this.offer.external_id,
          fromCard: true
        }
      });
    },
    installmentPlan() {
      this.$router.push({
        path: "/installment",
        query: {
          mark: this.offer.mark.slug,
          model: this.offer.folder.slug,
          car: this.offer.external_id,
          fromCard: true
        }
      });
    },
    ...mapActions({
      // liked: 'favorite/favorite/liked',
      openModal: "modal/modal-main/openModal",
      request: "request"
    }),
    // async like() {
    // 	await this.liked(this.offer.external_id)
    // },
    creditClick(carInfo) {
      let payload = {
        modal_data: carInfo,
        modal_component: "modal-credit",
        modal_title: "Заявка на автокредит",
        modal_sub_title: carInfo.name
      };
      this.openModal(payload);
    },
    // callback(carInfo) {
    // 	let payload = {
    // 		modal_data: carInfo,
    // 		modal_component: 'modal-callback',
    // 		modal_title: 'Обратный звонок',
    // 		modal_sub_title: carInfo.name
    // 	}
    // 	this.openModal(payload)
    // },
    tradeInClick(carInfo) {
      let payload = {
        modal_data: carInfo,
        modal_component: "modal-tradeIn",
        modal_title: "Заявка на Trade-In",
        modal_sub_title: carInfo.name
      };
      this.openModal(payload);
    }
    // ratingClick() {
    // 	let payload = {
    // 		modal_data: this.offer,
    // 		modal_component: 'modal-rating',
    // 		modal_title: ' Состояние автомобиля',
    // 		modal_sub_title: this.offer.name
    // 	}
    // 	this.openModal(payload)
    // },

    // installmentClick(carInfo) {
    // 	let payload = {
    // 		modal_data: carInfo,
    // 		modal_component: 'modal-installment',
    // 		modal_title: 'Заявка на рассрочку',
    // 		modal_sub_title: carInfo.name
    // 	}
    // 	this.openModal(payload)
    // },
    // async autoteka(carInfo) {
    // 	let payload = {
    // 		modal_data: carInfo,
    // 		modal_component: 'modal-autoteka',
    // 		modal_title: 'Отчет от ' + carInfo.createdAt,
    // 		modal_sub_title: carInfo.name
    // 	}
    // 	await this.openModal(payload)
    // },
  }
};
